<template>
  <div class="add-bank">
    <!--顶部导航-->
    <Navbar title="银行卡管理" :isSpecialBack="true" @goBack="handleBack" />
    <div class="content" v-if="bankCardList.length !== 0">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div v-for="item in bankCardList" :key="item.id">
          <addBankList
            :item="item"
            @setDefaultBankCardSuccess="handleSetDefaultBankCardSuccess"
          />
        </div>
      </van-list>
      <!--银行卡列表-->
    </div>
    <!--暂无数据-->
    <noData
      @clickNoData="goAddBank"
      :img="require('@/assets/style/bank-noData.png')"
      v-if="hasLoaded && !loading && bankCardList.length === 0"
    />
    <!--添加银行卡按钮-->
    <div class="footer-wrap" v-if="bankCardList.length !== 0">
      <div class="btn" @click="goAddBank">添加银行卡</div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import addBankList from "@/components/addBank/addBankList.vue";
import { getBankCardList, preCheck, getUserAllInfo } from "@/api/index.js";
import noData from "@/views/noData/index.vue";
import { infoErrorCode } from "@/utils/const";
import { setLocalStorageData } from "@/common/index";

export default {
  name: "addBank",
  components: {
    Navbar,
    addBankList,
    noData,
  },
  data() {
    return {
      bankCardList: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      pageSize: 10,
      isNavigatingAway: false,
      hasLoaded: false,
      infoErrorCode,
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    handleBack() {
    this.$router.back();
    },
    async goAddBank() {
      // 贷前检测
      const preCheckRes = await preCheck({});
      this.$store.commit("setPreCheckData", preCheckRes);
      setLocalStorageData("preCheckData", preCheckRes);
       if (infoErrorCode.includes(preCheckRes.code)) {
         await this.getUserInfo();
        this.$toast("请先完成资质认证");
        this.$router.push({
          name: "idCardBinding",
        });
        return;
      }
      this.$store.commit("setBankCardBindingFlag", '3');
      this.$router.push({
        name: "bankCardBinding",
      });
    },
    //获取用户信息
    async getUserInfo() {
      const res = await getUserAllInfo();
      if (res.code === 2000) {
        setLocalStorageData("UserAllInfo", res.data);
      }
    },
    refresh() {
      this.pageNumber = 1;
      this.finished = false;
      this.fetchPage({ reset: true });
    },
    handleSetDefaultBankCardSuccess(id) {
      this.bankCardList.forEach((item) => {
        if (item.id == id) {
          item.defaultState = 1;
        } else {
          item.defaultState = 0;
        }
      });
    },
    fetchPage({ reset }) {
      this.loading = true;
      getBankCardList({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code === 2000) {
          const list = res.data?.recordList || [];
          if (reset) {
            this.bankCardList = list;
          } else {
            this.bankCardList = [...this.bankCardList, ...list];
          }
          this.pageNumber++;
          this.finished = this.bankCardList.length >= (res.data?.total || 0);
          console.log(this.finished,"this.finished");
          
        }
        this.hasLoaded = true;
        this.loading = false;
      }).catch(() => {
        this.hasLoaded = true;
        this.loading = false;
      });
    },
    onLoad() {
      this.fetchPage({ reset: false });
    },
  },
};
</script>

<style scoped lang="scss">
.add-bank {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
}
.content {
  padding: 0px 16px;
}
.content-pb{
  padding-bottom: 130px;
}
.add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;
  font-size: 20px;
  height: 50px;
  background: #01abff;
  border-radius: 10px;
  color: #fff;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.footer-wrap {
  width: 100%;
  height: 110px;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  .btn {
    height: 50px;
    background: #1d70f7;
    border-radius: 30px;
    font-size: 18px;
    font-family: "Regular";
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 26px;
  }
}
.block{
  width: 100%;
  height: 115px;
}
</style>
